// © 2026 AttainIP Engineering
export function Card({ title, children, className = '' }: { title?: string; children: React.ReactNode; className?: string }) {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`}>
      {title && <div className="px-4 py-3 border-b border-gray-100 font-medium text-sm text-gray-700">{title}</div>}
      <div className="p-4">{children}</div>
    </div>
  );
}
